import React from "react";
import * as S from "./styles";

const Skeleton = ({ type }) => {
  const classes = `skeleton ${type}`;
  return (
    <S.wrapper>
      <div className={classes} />
    </S.wrapper>
  );
};
export default Skeleton;
